import React, { FC, ReactElement, useContext } from 'react'
import CLanguageHandler from '../../../../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../../../../../React/Common/Contexts'
import { PolicyFieldNames, TabNames, TELEPHONY_SERVER_ID_FIELD_NAME } from '../Constants/FieldNames'
import { POLICY_CONFIG_FILE_NAME, POLICY_CONFIG_PATH } from '../Constants/Constants'
import { ClientConfigurationModalLanguage } from '../../../../../../../i18n'
import { ConfigurableTableFieldForm } from '../../../../Molecules/ConfigurableTableFieldForm/ConfigurableTableFieldForm'
import { useTelSysType } from '../Hooks/useTelSysType'

type Props = {
    isViewOnly?: boolean
}

export const ClientConfigurationPolicyTab: FC<Props> = ({ isViewOnly }: Props): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    const telSysType: Definable<string> = useTelSysType(TELEPHONY_SERVER_ID_FIELD_NAME)

    return (
        <div className='table-tab-content'>
            <ConfigurableTableFieldForm
                namespacingFunction={(name: string): string => `${TabNames.POLICY}.${name}`}
                localisationFunction={(name: string): string => language.get(`ClientConfigurationModal_Policy_${name}`)}
                arrayFieldName={PolicyFieldNames.POLICIES}
                config={[POLICY_CONFIG_FILE_NAME, POLICY_CONFIG_PATH]}
                inputConfig={undefined}
                isViewOnly={isViewOnly}
                currentTelSysType={telSysType}
                allowAdd
                allowRemove
                showDefaults
                localisation={{
                    header: {
                        item: language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Policy_PolicyItem
                        ),
                        default: language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Policy_DefaultValue
                        ),
                        value: language.get(
                            ClientConfigurationModalLanguage.ClientConfigurationModal_Tab_Policy_ActualValue
                        )
                    }
                }}
            />
        </div>
    )
}
